// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBqw2WAbnpg0bSyX9dNIz3WvAny7dRYehA",
  authDomain: "crionsas-a5b17.firebaseapp.com",
  projectId: "crionsas-a5b17",
  storageBucket: "crionsas-a5b17.appspot.com",
  messagingSenderId: "823130339397",
  appId: "1:823130339397:web:637281afe9c73fe6b64b2c",
  measurementId: "G-Z3G61TNBEH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);



